import React, { useEffect, useState } from 'react';
import { GenerateImageStore } from '@/pages/generate-image/store';
import { GenerateVideoStore } from '@/pages/generate-video/store';
import MarketingStore from '@/store/marketing';
import membershipStore from '@/components/membership/store';
import { HelperCore } from '@/common/helper';
import TrailExaustedModal from "@/components/modal/trial-exhausted"
import { SVGPureIcon } from '@/ui';
import userStore from '@/store/user';
import { Spin } from 'antd';
import './index.scss';

interface TaskLoadingProps {
  cancelTask?: (item) => void;
  retryTask?: (item) => void;
  taskInfo?: any;
  type?: string;
  openTaskList?: () => void;
  customStyle?: string;
  position?: string;
  onOpenPaymentGateway?: () => void;
}

const TaskLoading: React.FC<TaskLoadingProps> = ({
  cancelTask,
  retryTask,
  taskInfo,
  type,
  customStyle,
  openTaskList,
  position,
  onOpenPaymentGateway,
}) => {
  const [showText, setShowText] = useState<string>('任务已提交，等待处理中...');
  const [taskDataInfo, setTaskDataInfo] = useState<any>({});
  const [showMemberBtn, setShowMemberBtn] = useState(false);
  // 格式化时间函数 - 不足一分钟按一分钟计算
  const formatTime = (seconds: number): string => {
    if (!seconds || seconds <= 0) return '1分钟';
    // 将秒数转换为分钟，向上取整
    const totalMinutes = Math.ceil(seconds / 60);

    const minutes = totalMinutes % 60;
    // 组装时间格式字符串
    let formattedTime = '';
    if (minutes > 0) {
      formattedTime += `${minutes}分钟`;
    } else {
      formattedTime += '1分钟';
    }
    return formattedTime;
  };

  // 打开收银台
  const openPaymentGateway = () => {
    onOpenPaymentGateway?.();
    if (HelperCore.isMac()) {
      TrailExaustedModal.show({
        isMember: true,
      });
      return;
    } else {
      membershipStore.setData({
        show: true,
        checkstandType: 'openMembership',
        feature: type === 'image' ? 'AIIMAGE_expressway' : 'AIVIDEO_expressway',
        position,
      });
    }
  };

  // 计算进度和剩余时间
  useEffect(() => {
    if (!taskInfo?.data) {
      return;
    }
    const taskData = JSON.parse(taskInfo.data);
    setTaskDataInfo(taskData);
    if (taskData?.status === 'submitted') {
      setShowText('任务已提交，等待处理中...');
      return;
    }

    if (taskData?.status === 'waiting') {
      // 分
      setShowText(
        `排队中，前方还有 ${taskData?.queue} 个任务\n预计剩余${formatTime(Math.ceil(taskData.queue_time))}`
      );
      return;
    }
    if (taskData?.status === 'processing') {
      const { consuming_time, scheduled_time } = taskData;
      const ct = consuming_time;
      const st = scheduled_time;
      let progress;
      // 如果消耗时间或计划时间为空，返回0
      if (ct == null || st == null) {
        progress = 0;
      }
      // 如果计划时间为0（防止除以0），返回0
      if (st === 0) {
        progress = 0;
      }
      // 计算进度百分比，最高不超过99%
      progress = Math.min(Math.floor((ct / st) * 100), 99);
      setShowText(
        `正在生成中...${progress}%\n预计剩余${formatTime(Math.ceil(taskData.queue_time))}`
      );
    }
  }, [taskInfo]);

  useEffect(() => {
    let expresswayUsable = (
      type === 'image' ? GenerateImageStore : GenerateVideoStore
    )?.memberBenefits?.expresswayUsable;
    // 高速队列 仅会员可用&&不是营销云
    setShowMemberBtn(
      expresswayUsable === 'member' && !MarketingStore.isMarketingCloud
    );
  }, [userStore?.membershipInfo?.is_member, userStore?.isWhite]);

  // 将文本分行显示
  const textLines = showText.split('\n');

  return (
    <div
      className={`task-loading absolute inset-0 ${type === 'video' ? 'bg-[rgba(0,0,0,0.2)]' : 'bg-[rgba(0,0,0,0.2)] backdrop-blur'} z-40 flex flex-col items-center justify-center ${customStyle}`}
    >
      {taskInfo?.status === 1 && (
        <>
          <Spin />
          <div className="flex flex-col items-center gap-2 mt-4">
            {textLines.map(
              (line, index) =>
                line.trim() !== '' && (
                  <div key={index} className="text-white text-center">
                    {index === 0 ? (
                      <span className="text-[16px]">{line}</span>
                    ) : (
                      <span className="text-[12px] opacity-50">{line}</span>
                    )}
                  </div>
                )
            )}
            <span className="text-white/50 text-[12px]">
              关闭页面后，可在左侧"
              <span className="text-white">我的作品</span>
              "中查看结果
            </span>
          </div>
          {taskDataInfo?.status === 'waiting' && showMemberBtn && (
            <div className="mt-16px">
              {/* 会员 或者白名单 进入高速队列 */}
              {userStore?.membershipInfo?.is_member ||
              taskDataInfo?.is_search_vip ? (
                <div
                  className="w-236px h-44px flex items-center justify-center gap-4px rounded-12px"
                  style={{
                    background:
                      'linear-gradient(90deg, rgba(0, 0, 0, 0) 5.29%, rgba(0, 0, 0, 0.35) 50%, rgba(0, 0, 0, 0) 95.19%)',
                  }}
                >
                  <img
                    className="size-20px"
                    src="https://p3.ssl.qhimg.com/t110b9a93015271508c134c8463.png"
                    alt=""
                  />
                  <div
                    className="text-transparent"
                    style={{
                      background:
                        'linear-gradient(147.33deg, #FFE9DE 16.4%, #FEB28A 96.15%)',
                      WebkitBackgroundClip: 'text, content-box',
                    }}
                  >
                    VIP队列加速中...
                  </div>
                  <img
                    className="size-20px"
                    src="https://p3.ssl.qhimg.com/t110b9a9301cf7cd80369d3d5a0.png"
                    alt=""
                  />
                </div>
              ) : (
                <div
                  className="w-236px h-44px flex items-center justify-center cursor-pointer gap-4px bg-[#00000059] rounded-12px"
                  onClick={openPaymentGateway}
                >
                  <img
                    className="size-20px"
                    src="https://p3.ssl.qhimg.com/t110b9a93015271508c134c8463.png"
                    alt=""
                  />
                  <div
                    className="text-transparent"
                    style={{
                      background:
                        'linear-gradient(147.33deg, #FFE9DE 16.4%, #FEB28A 96.15%)',
                      WebkitBackgroundClip: 'text, content-box',
                    }}
                  >
                    升级会员，立即加速
                  </div>
                  <img
                    className="size-16px"
                    src="https://p3.ssl.qhimg.com/t110b9a9301041cea23441f3fa4.png"
                    alt=""
                  />
                </div>
              )}
            </div>
          )}
          {cancelTask &&
            JSON.parse(taskInfo?.data || {})?.status === 'waiting' && (
              <div
                className="flex items-center text-white leading-[24px] justify-center cursor-pointer mt-16px rounded-[12px] text-[16px] px-24px py-8px bg-white/10 hover:bg-white/20 transition-colors"
                onClick={() => cancelTask && cancelTask(taskInfo)}
              >
                取消任务
              </div>
            )}
        </>
      )}
      {taskInfo?.status === 3 &&
        (type === 'video' ? (
          <div className="flex flex-col items-center">
            <img
              className="w-80px h-80px"
              src="https://p4.ssl.qhimg.com/t110b9a930125822799f4226280.png"
              alt=""
            />
            <div className="flex items-center justify-center mt-8px gap-4px text-[#FFFFFF]">
              <SVGPureIcon name="task-warn-icon" className="size-16px mt-2px" />
              {taskDataInfo?.status === 'risk'
                ? '生成的视频违规，请编辑后再次提交'
                : '生成失败'}
            </div>
            {taskDataInfo?.status !== 'risk' && (
              <div
                className="flex items-center justify-center cursor-pointer mt-16px w-[108px] h-[36px] gap-4px rounded-[40px] border border-[0.5px] border-white/30 bg-white/10 text-white px-16px py-8px hover:bg-white/20 transition-colors"
                onClick={() => retryTask && retryTask(taskInfo)}
              >
                <SVGPureIcon name="task-refresh" className="size-16px" />
                重试
              </div>
            )}
          </div>
        ) : (
          <div className="flex flex-col leading-[18px] items-center justify-center text-12px text-[rgba(255,255,255,0.60)]">
            <img
              className="w-80px h-80px mb-10px"
              src="https://p5.ssl.qhimg.com/t110b9a9301f0792b96f4dcd5ab.png"
              alt=""
            />
            {taskDataInfo?.status === 'risk' ? (
              <div>生成的图片违规，请编辑后再次提交</div>
            ) : (
              <>
                {taskDataInfo.edit_img_action === '' ? (
                  <>
                    {' '}
                    <div>
                      创意生成失败{' '}
                      <span
                        className="underline text-[#fff] cursor-pointer"
                        onClick={() => retryTask && retryTask(taskInfo)}
                      >
                        点击重试
                      </span>
                    </div>
                    <div>或尝试修改创意</div>
                  </>
                ) : (
                  <div>生成失败 </div>
                )}
              </>
            )}
          </div>
        ))}
    </div>
  );
};

export default TaskLoading;
